export default function headerSticky(element, data) {
    
    let stickyElHeight = element.offsetHeight;
    let lastScrollTop = 0;

    window.addEventListener('scroll', () => {       
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        let top = element.offsetHeight * (-1) + "px";

        if (scrollTop > lastScrollTop) {
            element.style.top = top;
        } else {
            element.style.top = "0";
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
};